import { FC } from 'react';

import ready from 'assets/images/ready.png';

import styles from './FourStep.module.css';

import { t } from 'utils';
import texts from '../../../texts';

export const FourStepCompany: FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.main}>
        <img src={ready} alt="ready" />
        <div style={{ marginLeft: '60px' }}>
          <h1 style={{ fontWeight: 'bold', color: '#1F77D5' }}>{t(texts.companyFourStepTitle)}</h1>
          <p>{t(texts.companyFourStepDesc)}</p>
        </div>
      </div>
    </div>
  );
};
